<template>
  <pbc-overlay ref='modal'
               @close="onClose"
               :disable-title="true"
               @done='onAddText'>
    <template #default="{}">
      <div class="h-full">
        <text-editing :component='newComponent'
                      :transform='newChild'
                      :transforms-and-source='transformsAndSource'
                      class="h-full"
                      @update='$emit("change")'
                      :partutil='partutil' />

      </div>
    </template>
  </pbc-overlay>

</template>
<script>
import { zip } from 'lodash';
import { types } from '@edit/tree/componentsdb.js';
import Searcher from '@edit/tree/searcher.js';
import TextEditing from '@components/editing/textEditing.vue';

export default {
  props: {
    partutil: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    holderData: {
      type: Object,
      required: true
    }
  },
  data() {
    const layer = {
      id: 'text',
      name: 'Text',
      zindex: 5,
      projection: 'orthogonal',
      direction: 'rightdown'
    }
    const {newChildren, newComponent, newParents, newChild, newComponents} = this.createTextToy(layer);
    return {
      firstUpdate:true,
      layer,
      newChildren,
      newComponent,
      newParents,
      newChild,
      newComponents
    }
  },
  components: {
    TextEditing,
  },
  mounted() {
  },
  methods: {
    addedEmptyText(component) {
      if (!component.text || component.text.trim().length === 0) {
        return true;
      }
      return false;
    },
    onAddText() {
      if (this.addedEmptyText(this.newComponents[0])) {
        this.onClose();
        return;
      }
      this.$emit('add-children', {
        newChildren: this.newChildren,
        newParents: this.newParents,
        newComponents: this.newComponents
      });

      this.$ana.track({
        eventCategory: 'instant',
        eventAction: 'add',
        extra: {
          type: 'text'
        }
      });

      this.$emit('done');
    },
    onClose() {
      if (this.newChildren) {
        const transformsToRemove = zip(this.newParents, this.newChildren).map( ([parent, child]) => {
          return {parent, child}
        });

        this.partutil.removeTransforms(transformsToRemove);
      }
      this.$emit('close');
    },
    createTextToy(layer) {
      if (this.newChild) {
        return;
      }
      const newComponentIn = types.text.createNew();
      newComponentIn.text = '';
      newComponentIn.bg = false;
      newComponentIn.bgcolor = '#000000'
      newComponentIn.color = '#ffffff'

      this.partutil.selectLayer(layer);
      const {
        newChildren,
        newParents,
        newComponents,
      } = this.partutil.addChildren([this.partutil.root], newComponentIn);
      newChildren.forEach( (child) => {
        child.transform.pos.x = 0;
        child.transform.pos.y = 0;
      });

      const newChild = newChildren[0];
      const newComponent = newComponents[0];
      console.log('newComponent', newComponent);

      return {newChildren, newComponent, newParents, newChild, newComponents};
   },
  },
  computed: {
  }
}
</script>
<style>
.instant-text-button {
  @apply w-8 h-8 border border-solid border-white mr-2;
}
</style>
